import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Company } from '../../services/types';
import { resetReduxState } from '../actions';

interface CompanyState {
  company: Company | null;
  companyId: string | null;
  companyName: string | null;
  companyDescription: string | null;
  internalAdminName: string | null;
  companies: Company[];
  totalCount: number;
  lastFetchedReportId: string | null;
  currentPage: number;
  pageSize: number;
}

const initialState: CompanyState = {
  company: null,
  companyId : null,
  companyName: null,
  companyDescription: null,
  internalAdminName: null,
  companies: [],
  totalCount: 0,
  lastFetchedReportId: null,
  currentPage: 1,
  pageSize: 10,
};


const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCompany: (state, action: PayloadAction<{ company: Company }>) => {
      state.company = action.payload.company;
      state.companyId = action.payload.company.companyId;
      state.companyName = action.payload.company.companyName;
      state.companyDescription = action.payload.company.companyDescription;
      state.internalAdminName = action.payload.company.internalAdminName;
    },
    
    clearCompany: (state) => {
      state.company = null;
      state.companyId = null;
      state.companyName = null;
      state.companyDescription = null;
    },

    setCompanies: (
        state,
        action: PayloadAction<{
        data: Company[];
        totalCount: number;
        }>
    ) => {
        state.companies = action.payload.data;
        state.totalCount = action.payload.totalCount;
    },

    // Update pagination
    setCurrentPage: (state, action: PayloadAction<number>) => {
        state.currentPage = action.payload;
    },

    setPageSize: (state, action: PayloadAction<number>) => {
        state.pageSize = action.payload;
        state.currentPage = 1; // Reset to first page when changing page size
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetReduxState, (state) => {
      // Reset to initial state
      state.companyId = null;
    });
  },
});

export const { setCompany, setCompanies, setCurrentPage, setPageSize } = companySlice.actions;
export default companySlice.reducer; 